export default __webpack_public_path__ + "static/media/phone.f9dbfd7f.svg";